export default __webpack_public_path__ + "static/media/dollar.6b08aa6f.svg";